import { render, staticRenderFns } from "./stockItemsTable.vue?vue&type=template&id=6e7989dc&"
import script from "./stockItemsTable.vue?vue&type=script&lang=ts&"
export * from "./stockItemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports